module.exports = __webpack_public_path__ + "static/media/invitation-header.16dc3060.png";